// Runtime environment config
// In production: reads from window.__ENV__ (injected by docker-entrypoint.sh)
// In development: falls back to import.meta.env (Vite inlines at build time)

interface EnvConfig {
  VITE_API_URL: string;
  VITE_API_BASE_URL: string;
  VITE_GOOGLE_OAUTH_CLIENT_ID: string;
  VITE_ENV: string;
}

declare global {
  interface Window {
    __ENV__?: Partial<EnvConfig>;
  }
}

export function getEnv(key: keyof EnvConfig): string {
  // Runtime injection takes precedence (production on k8s)
  const runtimeValue = window.__ENV__?.[key];
  if (runtimeValue !== undefined && runtimeValue !== '') {
    return runtimeValue;
  }

  // Fallback to Vite build-time values (local dev)
  return (import.meta.env[key] as string) || '';
}
